import { render, staticRenderFns } from "./MigrateMessages.vue?vue&type=template&id=518cacd3&"
import script from "./MigrateMessages.vue?vue&type=script&lang=js&"
export * from "./MigrateMessages.vue?vue&type=script&lang=js&"
import style0 from "./MigrateMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports